import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import {
    TGetBookingResponse
} from 'libraries/service/resources/booking/interfaces/IGetBookings';
import { Yii } from 'libraries/interfaces/Yii';
import { CardComponent } from 'libraries/ui_card/card.component';

interface ILabels {
    cardTitle: string;
}

@Component({
    selector: 'booking-contacts',
    template: `
        <card #cardContainer [isCollapsible]="true">
            <div class="card-header-content">
                <div class="title" (click)="menuToggleCard()">
                    {{ labels.cardTitle }}
                </div>
            </div>
            <div class="card-body-content">
                <booking-contacts-contact *ngIf="booking.customer"
                                          [traveller]="booking.customer"
                                          personRole="customer"></booking-contacts-contact>

                <booking-contacts-contact *ngIf="booking.agency"
                                          [traveller]="booking.agency"
                                          personRole="agency"></booking-contacts-contact>

                <ng-container *ngFor="let traveller of booking.traveller">
                    <booking-contacts-contact *ngIf="traveller.xId !== booking.customer.xId"
                                              [traveller]="traveller"
                                              personRole="traveller"></booking-contacts-contact>
                </ng-container>
            </div>
        </card>
    `,
    styles: [`
        booking-contacts-contact {
            display: block;
            min-width: 220px;
            border-bottom: 1px solid rgba(189, 195, 199, 0.2);
            border-right: 1px solid rgba(189, 195, 199, 0.2);
        }

        booking-contacts-contact:nth-child(even) {
            background-color: #f2f2f2;
        }

        booking-contacts-contact:nth-child(odd) {
            background-color: #f9fafc;
        }

        .card-header-content .title {
            cursor: pointer;
        }
    `]
})
export class BookingContactsComponent {
    @ViewChild('cardContainer')
    public cardContainer: CardComponent;

    @Input()
    public booking: TGetBookingResponse;

    @Output()
    public readonly onCardTitleClick: EventEmitter<string> =  new EventEmitter();

    public labels: ILabels = {
        cardTitle: Yii.t('wui-shared-js', 'Contacts'),
    };

    public name: string = 'bookingContacts';

    public menuToggleCard(): void{
        this.onCardTitleClick.emit(this.name);
    }
}
